module.exports = __webpack_public_path__ + "static/bg-menu-sp-ba2bff59fc8c5605831db6d0eed428bb.jpg";